/* ── Base ── */
.card {
  border-radius: var(--radius-lg);
  overflow: hidden;
}

/* ── Variants ── */
.elevated {
  background-color: var(--color-bg-card);
  box-shadow: var(--shadow-md);
}

.outlined {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
}

.flat {
  background-color: var(--color-bg-secondary);
}

/* ── Padding ── */
.pad-none {
  padding: 0;
}

.pad-sm {
  padding: var(--space-3);
}

.pad-md {
  padding: var(--space-4);
}

.pad-lg {
  padding: var(--space-6);
}

/* ── Compound Sections ── */
.header {
  padding: var(--space-4);
  border-bottom: 1px solid var(--color-border);
  font-weight: var(--font-weight-semibold);
}

.body {
  padding: var(--space-4);
}

.footer {
  padding: var(--space-4);
  border-top: 1px solid var(--color-border);
}

/* When card has no padding, sections provide their own */
.pad-none > .header,
.pad-none > .body,
.pad-none > .footer {
  padding: var(--space-4);
}

/* When card has padding, sections use zero padding to avoid doubling */
.pad-sm > .header,
.pad-sm > .body,
.pad-sm > .footer,
.pad-md > .header,
.pad-md > .body,
.pad-md > .footer,
.pad-lg > .header,
.pad-lg > .body,
.pad-lg > .footer {
  padding: 0;
  padding-bottom: var(--space-3);
}

.pad-sm > .header,
.pad-md > .header,
.pad-lg > .header {
  margin-bottom: var(--space-3);
  border-bottom: 1px solid var(--color-border);
  padding-bottom: var(--space-3);
}

.pad-sm > .footer,
.pad-md > .footer,
.pad-lg > .footer {
  margin-top: var(--space-3);
  border-top: 1px solid var(--color-border);
  padding-top: var(--space-3);
  padding-bottom: 0;
}
